export const RXDB_OPPORTUNITY_SCHEMA = {
    title: 'Opportunity Schema',
    version: 1,
    type: 'object',
    primaryKey: '_id',
    additionalProperties: true,
    properties: {
        _id: { type: 'string', maxLength: 100 },
        id: { type: 'string', maxLength: 100 },
        status: { type: ['string', 'null'], maxLength: 100 },
        name: { type: ['string', 'null'], maxLength: 200 },
        monthlyAmount: { type: ['number', 'null'] },
        mainQuoteId: { type: ['string', 'null'], maxLength: 50 },
        lastModifiedDate: { type: ['string', 'null'] },
        creationDate: { type: ['string', 'null'] },
        account: { type: ['object', 'null'] }
    },
    required: [
        '_id'
    ]
};